// removed by extract-text-webpack-plugin
module.exports = {"calendar-radio":"calendar-radio","selected":"selected","calendar-radio-state":"calendar-radio-state","calendar-radio-name":"calendar-radio-name"};


//////////////////
// WEBPACK FOOTER
// ./src/application/component/calendar-radio/calendar-radio.style.sass
// module id = h3dC
// module chunks = 0